import React from 'react';
import { connect } from 'react-redux';

import ButtonLeave from '../Buttons/ButtonLeave';

import "./Room.css";

const ScenarioOverlay = ({ isRoomHost, isTimeStamp }) => {
    return (!isRoomHost && !isTimeStamp) && (
        <div className="scenario_overlay_container">
            <div className='row'>
                <div className='col-md-12 scenario_overlay_paragraph'>
                    <ButtonLeave />
                </div>
                
                <div className='col-md-12'>
                    <div className="scenario_overlay_paragraph">
                        {!isTimeStamp && (<h4>Por favor, aguade seu avaliador...</h4>)}
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(ScenarioOverlay);